<template>
  <div class="holiday-manage-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />

    <div class="list-container">
      <div class="inner-container">
        <avue-crud
          :option="tableOption"
          :data="tableData"
          ref="holidayTable"
          :page.sync="page"
          :search.sync="searchForm"
          @on-load="getLists"
          @search-change="searchChange"
          @search-reset="searchReset"
          @refresh-change="getLists"
          @selection-change="selectionChange"
        >
          <template slot="menuLeft">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              v-if="permission['holiday_audit']"
              @click="handleAdd()"
            >
              假期事件
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              v-if="permission['holiday_audit']"
              @click="handleEditHoliday()"
            >
              修改
            </el-button>            
            <el-button
              size="small"
              plain
              @click="exportShow"
              icon="el-icon-download"
            >
              导出数据
            </el-button>
            <el-button
              size="small"
              plain
              @click="importShow"
              icon="el-icon-upload2"
              >导入模版
            </el-button>
          </template>
          <template slot-scope="scope" slot="menu">
            <el-button
              type="success"
              size="small"
              icon="el-icon-arrow-right"
              plain
              @click.stop="handleDetail(scope['row'])"
              >详情
            </el-button>
            <!-- v-if="userInfo.user_id == scope.row.managerUser" -->
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              v-if="scope['row']['checkStatus'] !== 0 && scope['row']['canEdit']"
              @click.stop="handleEdit(scope['row'], scope['index'])"
              >编辑
            </el-button>
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              v-if="scope['row']['checkStatus'] == 0"
              @click.stop="handleAccounting(scope['row'])"
              >核算
            </el-button>
          </template>
          <!-- 自定义搜索框 -->
          <template slot="search">
            <el-form-item label="事件类型">
              <el-select
                v-model="searchForm['eventTypeArray']"
                multiple
                placeholder="请选择类型"
                collapse-tags
              >
                <el-option
                  v-for="item in eventTypeAarray"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 新增部门筛选 -->
            <el-form-item label="公司" label-width="60px">
              <el-select
                v-model="searchForm['companyId']"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <div class="block"> -->
              <el-form-item label="时间" label-width="60px">
                <el-date-picker
                  v-model="searchForm['annual']"
                  type="year"
                  placeholder="选择年"
                  format="yyyy"
                  value-format="yyyy">
                </el-date-picker>
              </el-form-item>
            <!-- </div> -->
          </template>
          <!-- 搜索按钮 -->
          <template slot="searchMenu" slot-scope="{ row }">
            <el-button type="primary" @click="save(row)">保存</el-button>
          </template>
          <!-- 表格右侧筛选插槽 -->
          <template slot="menuRight">
            <el-tooltip class="item" effect="dark" content="显隐" placement="top">
              <el-button
                icon="el-icon-s-operation"
                size="small"
                circle
                @click="operation"
              ></el-button>
            </el-tooltip>
          </template>
          <!-- 表格插槽 -->
          <template slot="dayNum" slot-scope="{ row }">
            <span v-if="row['recordType'] == 1" class="green-num">+ {{Number(row['vacationDay']).toFixed(1)}}</span>
            <span v-else class="red-num">- {{Number(row['vacationDay']).toFixed(1)}}</span>
          </template>
        </avue-crud>
      </div>
    </div>

    <!-- 2022/02/15 新增数据导入 -->
    <uploadForm
      uploadUrl="/api/hr/staffinfo/import-data"
      openUrl="/api/hr/staffinfo/export-template"
      uploadTitle="假期管理数据导入"
      @refreshData='refreshData'
      ref="uploadDialog"
    />

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />

    <Options
      ref="Options"
      :plainOptions="columnOption"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />

    <el-dialog
      :close-on-click-modal="false" title="详情" :visible.sync="dialogTableVisible">
      <TableForm :tableForm="tableForm"></TableForm>
    </el-dialog>

    <ExportData ref="exportData" @exportDownload="exportDownload" />
    <!-- @saveOpration="saveOpration"
         @saveOprationReduce="saveOprationReduce" -->
    <el-dialog
      :close-on-click-modal="false" class="typeOther" title="核算" :visible.sync="accountingVisible">
      <AccountingForm
        ref="accountingForm"
        :checkType="checkType"
        :userId="checkId"
        :eventId="eventId"
        :annual="annual"
        :filterYear="searchForm['annual']"
        @closeDialog="closeAccountingDialog"
      ></AccountingForm>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { tableConfig } from './config.js'
import { downLoadTemplate } from "@/router/downLoadTem";
import Options from "@/components/ShowHidden/showhidden"
import TagsCloud from "@/components/TagsCloud/TagsCloud"
import SelectPerson from "@/components/SelectPersonnel/person"
import AccountingForm from "./components/accounting"
import TableForm from "./components/tableForm"
import ExportData from "@/components/exportData/exportData"
import { getHolidayList, holidayDict } from "@/api/hr/holiday"
import { getListData } from "@/api/system/dept"
import uploadForm from "@/components/uploadForm/uploadForm";
export default {
  name: 'holiday',
  data() {
    return {
      checkId: '',
      checkType: '',
      eventId: '',
      annual: '',
      eventTypeAarray: [],
      dialogTableVisible: false,
      accountingVisible: false,
      companyList: [],
      tableForm: {},
      files: [],
      tableData: [],
      tableOption: tableConfig(this.selectPersonClick),
      columnOption: tableConfig(this.selectPersonClick).column,
      timePic: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      // searchForm: {
      //   checkStatus: '',
      //   userName: '',
      //   userId: '',
      //   eventTypeArray: [],
      //   vacationType: '',
      //   annual: '',
      //   companyId: ''
      // },
      searchForm: {},
      selectionList: [],
      checkUserList: []
    }
  },
  components: {
    Options,
    SelectPerson,
    AccountingForm,
    TagsCloud,
    TableForm,
    ExportData,
    uploadForm,
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
    setForm() {
      let obj = {
        checkStatus: '',
        userName: '',
        userId: '',
        eventTypeArray: [],
        vacationType: '',
        annual: '',
        companyId: ''     
      }
      let newDate = new Date()
      obj.companyId = `${this.userInfo.companyId}`
      obj.annual = `${newDate.getFullYear()}`
      return obj
    }
  },  
  mounted() {
    if(!this.permission['holiday_audit']){
      this.tableOption['menu'] = false
    }else {
      this.tableOption['menu'] = true
    }
    this.searchForm = JSON.parse(JSON.stringify(this.setForm))
    this.getHolidayDic()
    this.getCompanyList()
  },
  activated() {
    this.getLists()
  },
  methods: {
    handleEditHoliday() {
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行修改')
      }else if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        // 打开核算框
        this.handleAccounting(data)
      }else{
        this.$message.error('请选择一条数据进行编辑')
      }
    },

    selectionChange(list) {
      this.selectionList = list
    },

    async getCompanyList() {
      let params = {
        deptCategory: 1
      }
      let res = await getListData(params)
      if(res.data.code == 200){
        // 处理数据
        this.companyList = res.data.data
      }
    },
    importShow() {
      this.$refs.uploadDialog.showModel()
    },
    refreshData() {
      this.$message({
        type: "success",
        message: "上传成功",
      })
      this.onLoad(this.page)
    },    
    getHolidayDic() {
      let self = this
      let dicArray = []
      holidayDict().then(res => {
        if(res['data']['code'] == '200'){
          res['data']['data'].map(item => {
            dicArray.push({
              dictValue: item,
              dictKey: item
            })
          })
          self.eventTypeAarray = dicArray
        }
      })
    },

    selectPersonClick() {
      this.searchForm['userNameArray'] = []
      this.searchForm['userName'] = ''
      this.$refs.selectperson.showmode();
    },

    setPeople(val) {
      // console.info(val, 'setPeople')
      this.checkUserList = val;
      this.getVisitPeople();
    },
    // 设置绑定人员数据
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.searchForm['userName'] = people.join(",");
        this.searchForm['userId'] = ids.join(",");
      });
    },
    // 获取假期管理列表
    getLists() {
      let self = this
      let params = {
        current: this.page['currentPage'],
        size: this.page['pageSize'],
        companyId: this.searchForm.companyId,
        ...this.searchForm
      }

      getHolidayList(params).then(res => {
        // console.info(res, 'getHolidayList')
        if(res['data']['code'] == '200'){
          self.tableData = res['data']['data']['records']
          self.page.total = res['data']['data']['total']
          // 处理数据
          self.tableData.map((item, index) => {
            // 假期时间
            item.timeRange = `${item['vacationBeginTime']}-${item['vacationEndTime']}`
          })
        }
      })
    },

    handleDetail(data) {
      // let self = this
      this.dialogTableVisible = true
      this.tableForm = data
      this.tableForm['userString'] = this.changeArrayToString(data['userName'])
      // 查询详细数据
      // getHolidayEventDetail({id: data['id']}).then(res => {
      //   console.info(res)
      //   if(res['data']['code'] == 200){
      //     self.dialogTableVisible = true
      //     self.tableForm = res['data']['data']
      //     self.tableForm['userString'] = self.changeArrayToString(res['data']['data']['userName']) 
      //   }
      // })
    },

    handleAdd() {
      this.$router.push({
        path: `/holidayManage/holidayEventAdd`
      })
    },

    returnData(data) {
      this.tableOption['column'] = data;
    },

    handleEdit(data) {
      this.$router.push({
        path: '/holidayManage/holidayEventEdit',
        query: {
          holidayId: data['id']
        }
      })
    },

    // 关闭核算
    closeAccountingDialog() {
      this.accountingVisible = false
      this.getLists()
    },

    //显隐
    operation() {
      // let origencolum = this.option.column;
      this.$refs.Options.showmode();
    },    

    // 核算
    handleAccounting(data) {
      // console.info(data, 'accounting')
      this.checkId = data['userId']
      this.checkType = data['recordType']
      this.eventId = data['id']
      this.annual = data['annual']
      if(data['recordType'] == -1){
        this.$message({
          type: "warning",
          message: "该条数据无法核算",
        })
      }else{
        if(this.$refs['accountingForm']) this.$refs['accountingForm'].resetForm()
        this.accountingVisible = true
      }
    },

    save() {},

    // 导出
    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
      let page = this.page;
      let data = {
         export: value.code,
      };
      if (value.code == 1) {
        data = {
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
          ...data
        };
      } else if (value.code == 2) {
        // delete form["current"];
        // delete form["size"];
        data = {
          ...this.searchForm,
          ...data
        };
      }
      downLoadTemplate("/api/hr/vacationrecord/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    searchChange(params, done) {
      if(params['eventTypeArray'] && params['eventTypeArray'] !== []){
        let newEventTypeArray = params['eventTypeArray'].map(item => {
          return item
        })

        this.searchForm['vacationType'] = newEventTypeArray.join(',')
      }else{
        this.searchForm['vacationType'] = ''
      }
      let filterParams = {
        checkStatus: this.searchForm['checkStatus'],
        vacationType: this.searchForm['vacationType'],
        userId: this.searchForm['userId'],
        annual: this.searchForm['annual']
      }
      // this.page =  {
      //   currentPage: 1,
      //   total: 0,
      //   layout: "total,pager,prev, next",
      //   background: false,
      //   pageSize: 10,
      // },

      this.page['currentPage'] = 1
      this.getLists(filterParams)
      done()
    },
    searchReset() {
      this.searchForm = {
        checkStatus: '',
        userName: '',
        userId: '',
        eventTypeArray: [],
        vacationType: '',
        annual: ''        
      }
      this.page['currentPage'] = 1
      this.getLists()
    },

    sortChange() {

    },

    cloudTages(data) {
      this.files = data;
    },
    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },

    changeArrayToString(initArr) {
      let newString = initArr.map(item => {
        return item
      })
      return newString.join(',')
    }
  }
}
</script>
<style lang="scss" scoped>
.holiday-manage-container{
  /deep/.el-badge__content{
    line-height: 16px;
    padding: 0px 5px;
  }
  .list-container{
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
  }
  .inner-container{
    width: 98%;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 30px !important;
    .green-num{
      color: #19BE6B;
      font-size: 13px;
      font-weight: 600;
    }
    .red-num{
      color: #F56C6C;
      font-size: 13px;
      font-weight: 600;
    }
  }
}
.table-con {
  border-collapse: collapse;
	margin-top: 5px;
  td{
    font-size: 13px;
    border: 0.5px solid #ccc;
    background-color:#ffffff;
    height:25px;
    line-height:150%;    
  }
  th{
    font-weight: 400;
    font-size: 13px;
    background-color:#ffffff;
    height:25px;
    line-height:150%;  
    border: 0.5px solid #ccc;
  }
}
.font-center{ text-align:center}
.btbg{background:#e9faff !important;}
.btbg1{background:#f2fbfe !important;}
.btbg2{background:#f3f3f3 !important;}
/deep/ .el-dialog{
  border-radius: 5px;
    overflow: hidden;
}
/deep/ .typeOther .el-dialog__body{
  padding: 30px 100px;
}
/deep/ .el-dialog__header{
  // background-color: rgba(245, 245, 245, 1);
}
/deep/ .avue-group--card:last-child{
  margin-bottom:0px ;
}
</style>